<!--
  Copyright (C) 2023 Fair Supply Analytics Pty Ltd - All Rights Reserved
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential.
-->

<div *ngIf="loaded" [class.hidden]="!active">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
